export class RequestModel {
  id: number
  procurementCategory: string
  ecmIds: string
  ticketsIds: string
  organizationalUnits: string
  ticketsCreatedOn: string
  requestStatusUniqueId: string
  requestStatusName: string
}

export class CheckSendOpnForConfirmationModel {
  id: number
  isTrueOPN2: boolean
  isTrue: boolean
}

export class RequestDetailsModel {
  id: number
  requestName: string
  budgetStatusId: number
  procurementCategoryId: number
  procurementCategoryName: string
  procurementModelId: number
  requestStatus: string
  requestAssignedUser: string
  requestAssignedUserErpId: string
  requestSubject: string
  plannedRoundsNumber: string
  createdByName: string
  createdOn: Date
  updatedByName: string
  updatedOn: Date
  requestAssignedUserHistoryList: RequestAssignedUserHistoryModel[]
}

export class RequestAssignedUserHistoryModel {
  assignedUser: string
  createdBy: string
  createdOn: Date
}

export class RequestSaveModel {
  id: number
  requestName: string
  budgetStatusId: number
  procurementCategoryId: number
  procurementModelId: number
  requestSubject: string
  plannedRoundsNumber: string
}

export class RequestStatusModel {
  id: number
  label: string
}

export class RequestMessageSendModel {
  id: number
  message: string
}

export class RequestSendModel {
  id: number
}


export class RequestMessageModel {
  requestId: number
	messageId: number;
  message: string
	messageFromUserId: number;
	messageFromUserFullName: string;
	messageFromUserInitials: string;
  messageCreatedOn: Date
  activity: string
}

export class OpnIntroductionModel {
  requestSubject: string
}

export class RequestStatusUniqueIdentifier {
	static inProgress: string = "InProgress"
	static onApproval: string = "OnApproval"
	static approved: string = "Approved"
	static rejected: string = "Rejected"
  static changesBack: string = "ChangesBack"
	static roundStarted: string = "RoundStarted"
	static supplierEvaluationRequired: string = "SupplierEvaluationRequired"
	static finished: string = "Finished"
	static canceled: string = "Canceled"
}

export class RequestStatusUniqueModel {
  requestStatus: string
}

export class RequestDeadlineModel {
  deadlineForCompletion: Date
}

export class RequestOpnConsentModel {
  requestId: number;
  isGivenConsent : boolean;
  remark: string;
}

export class RequestOpnConsentListModel{
  userId: number
  userFullName: string
  consentDate: Date
  memberType: number
  memberTypeName: string
}

export enum MemberType {
  teamMember = 1,
  boardMember = 2
}
